import React from "react";
import ReviewManagementDetailed from "../../features/reviewmanagementdetailed"
import { OverwriteReviewProvider } from '../../features/revieweditmodal/hooks/OverwriteReviewContext';


const ReviewManagementDetailedPage = () => <OverwriteReviewProvider><ReviewManagementDetailed /></OverwriteReviewProvider>

export default ReviewManagementDetailedPage;